import type { ThemeEarningsColumnLayout } from '../theme-earnings-table/ThemeEarningsTable';
import styles from './EarningsReportingSummary.module.scss';

export const REPORTED_TODAY_COLUMN_LAYOUT: Record<
  string,
  ThemeEarningsColumnLayout
> = {
  rank: {
    headerClassName: styles.rankHeader,
    cellClassName: styles.rankCell,
    headerAlignment: 'start',
    cellAlignment: 'center',
  },
  company: {
    headerClassName: styles.companyHeader,
    cellClassName: styles.companyCellWrapper,
    headerAlignment: 'start',
    cellAlignment: 'left',
  },
  'scheduled-date': {
    headerClassName: styles.dateHeader,
    cellClassName: styles.dateCell,
    headerAlignment: 'start',
    cellAlignment: 'left',
  },
  guidance: {
    headerAlignment: 'start',
    cellAlignment: 'left',
  },
  'eps-surprise-pct': {
    headerAlignment: 'end',
    cellAlignment: 'end',
  },
  'revenue-surprise-pct': {
    headerAlignment: 'end',
    cellAlignment: 'end',
  },
  'return-1d-pct': {
    headerAlignment: 'end',
    cellAlignment: 'end',
  },
  'earnings-drivers': {
    headerClassName: styles.flexHeader,
    cellClassName: styles.topicsCell,
    headerAlignment: 'start',
    cellAlignment: 'left',
  },
};
